/* ============================================================
   Volopharm Produktseite – Button-Text-Replacement (v2)
   ============================================================
   Änderung ggü. v1:
   - Patcht jetzt auch den Shopify Payment-Button von Prestige
     (nicht nur den Subscriptions-App-Button).
   - Erweitertes Set an Selektoren, mehr Text-Pattern.
   ============================================================ */

(function () {
  'use strict';

  var NEW_BUTTON_TEXT = 'Jetzt bestellen';

  var TEXTS_TO_REPLACE = [
    'Jetzt zum Checkout',
    'Zum Checkout',
    'Direkt kaufen',
    'Direkt zur Kasse',
    'Buy now',
    'Buy it now',
    'Check out',
    'Kasse'
  ];

  // Selektoren, in denen wir nach Buttons suchen
  var BUTTON_SELECTORS = [
    '.shopify_subscriptions_app_block button[type="submit"]',
    '.shopify-payment-button button',
    '.shopify-payment-button [role="button"]',
    '[data-shopify="payment-button"] button',
    'button.shopify-payment-button__button',
    '.shopify-payment-button__button--unbranded'
  ];

  function shouldReplace(currentText) {
    var trimmed = (currentText || '').trim();
    if (!trimmed) return false;
    if (trimmed === NEW_BUTTON_TEXT) return false;

    var lower = trimmed.toLowerCase();
    for (var i = 0; i < TEXTS_TO_REPLACE.length; i++) {
      if (lower.indexOf(TEXTS_TO_REPLACE[i].toLowerCase()) !== -1) {
        return true;
      }
    }
    return false;
  }

  function patchButton(button) {
    if (!button) return;
    if (button.dataset.vpTextPatched === '1') {
      // Bereits gepatcht, aber durch Re-Render evtl. übersteuert?
      // Erneut prüfen.
    }

    // Versuche, den richtigen Text-Knoten zu finden
    var textNode = findTextNode(button);
    var currentText = textNode ? textNode.textContent : button.textContent;

    if (!shouldReplace(currentText)) return;

    if (textNode) {
      var leading = textNode.textContent.match(/^\s*/)[0];
      var trailing = textNode.textContent.match(/\s*$/)[0];
      textNode.textContent = leading + NEW_BUTTON_TEXT + trailing;
    } else {
      // Fallback: button hat nur Text-Children, kompletten Text setzen
      // Aber NUR wenn keine inneren Elements vorhanden, sonst zerstören wir Markup
      if (button.children.length === 0) {
        button.textContent = NEW_BUTTON_TEXT;
      } else {
        // Tiefer suchen: alle Descendant-TextNodes durchgehen
        var deepNode = findDeepTextNode(button);
        if (deepNode) {
          var l2 = deepNode.textContent.match(/^\s*/)[0];
          var t2 = deepNode.textContent.match(/\s*$/)[0];
          deepNode.textContent = l2 + NEW_BUTTON_TEXT + t2;
        }
      }
    }

    button.dataset.vpTextPatched = '1';
  }

  function findTextNode(element) {
    for (var i = 0; i < element.childNodes.length; i++) {
      var node = element.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0) {
        return node;
      }
    }
    return null;
  }

  function findDeepTextNode(element) {
    var walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          if (node.textContent.trim().length > 0) {
            return NodeFilter.FILTER_ACCEPT;
          }
          return NodeFilter.FILTER_SKIP;
        }
      }
    );
    return walker.nextNode();
  }

  function patchAllButtons() {
    BUTTON_SELECTORS.forEach(function (selector) {
      var buttons = document.querySelectorAll(selector);
      buttons.forEach(patchButton);
    });
  }

  function init() {
    patchAllButtons();

    var observer = new MutationObserver(function (mutations) {
      var shouldRecheck = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.addedNodes.length > 0 || m.type === 'characterData') {
          shouldRecheck = true;
          break;
        }
      }
      if (shouldRecheck) {
        patchAllButtons();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   Volopharm Produktseite – Abo-Widget-Logik
   ============================================================
   Zwei Aufgaben:
   1. Default-Auswahl auf "Einmaliger Kauf" setzen (beim Laden)
   2. Die beiden Policy-Texte nur anzeigen, wenn "Im Abo kaufen
      und sparen" gewählt ist – beim Einmalkauf ausblenden.

   Selektoren basieren auf der Shopify-Subscriptions-App-Struktur:
   - One-Time-Radio:  input.one_time_purchase_option_app_block
                      (data-radio-type="one_time_purchase")
   - Abo-Radio:       die anderen radio-inputs im selben Widget
   - Policy-Text 1:   p.shopify_subscriptions_app_policy
   - Policy-Text 2:   small#shopify-buyer-consent
   ============================================================ */

(function () {
  'use strict';

  var ONE_TIME_RADIO_SELECTOR = 'input.one_time_purchase_option_app_block, input[data-radio-type="one_time_purchase"]';
  var ALL_RADIOS_SELECTOR = '.shopify_subscriptions_app_block input[type="radio"], .shopify_subscriptions_fieldset input[type="radio"]';
  var POLICY_SELECTORS = [
    'p.shopify_subscriptions_app_policy',
    'small#shopify-buyer-consent',
    '#shopify-buyer-consent'
  ];

  var defaultApplied = false;

  function getOneTimeRadio() {
    return document.querySelector(ONE_TIME_RADIO_SELECTOR);
  }

  function isOneTimeSelected() {
    var oneTime = getOneTimeRadio();
    return oneTime ? oneTime.checked : false;
  }

  function setPolicyVisibility() {
    var hide = isOneTimeSelected();
    POLICY_SELECTORS.forEach(function (selector) {
      var els = document.querySelectorAll(selector);
      els.forEach(function (el) {
        // Nur verstecken/zeigen – wir merken uns NICHT den Originalzustand,
        // da diese Texte standardmäßig sichtbar sind.
        if (hide) {
          el.style.display = 'none';
        } else {
          el.style.display = '';
        }
      });
    });
  }

  function applyDefaultOnce() {
    if (defaultApplied) return;
    var oneTime = getOneTimeRadio();
    if (!oneTime) return;

    // Nur setzen, wenn nicht schon One-Time gewählt ist
    if (!oneTime.checked) {
      oneTime.checked = true;
      // Change-Event feuern, damit die App ihren internen State + Preis aktualisiert
      oneTime.dispatchEvent(new Event('change', { bubbles: true }));
      oneTime.dispatchEvent(new Event('click', { bubbles: true }));
    }
    defaultApplied = true;
    setPolicyVisibility();
  }

  function attachRadioListeners() {
    var radios = document.querySelectorAll(ALL_RADIOS_SELECTOR);
    radios.forEach(function (radio) {
      if (radio.dataset.vpAboListener === '1') return;
      radio.addEventListener('change', function () {
        // kleiner Timeout, damit die App ihren eigenen State zuerst setzt
        setTimeout(setPolicyVisibility, 0);
      });
      radio.dataset.vpAboListener = '1';
    });
  }

  function init() {
    // Versuche initial den Default zu setzen + Listener zu binden
    applyDefaultOnce();
    attachRadioListeners();
    setPolicyVisibility();

    // Das Widget wird von der App per JS nachgeladen/neu gerendert.
    // MutationObserver fängt das ab und wendet Logik erneut an.
    var observer = new MutationObserver(function () {
      attachRadioListeners();
      // Default nur einmal anwenden (sonst überschreiben wir die
      // bewusste Nutzer-Auswahl bei jedem Re-Render)
      if (!defaultApplied) {
        applyDefaultOnce();
      }
      setPolicyVisibility();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Sicherheitsnetz: nach kurzen Verzögerungen nochmal versuchen,
    // falls die App erst spät rendert.
    setTimeout(function () {
      applyDefaultOnce();
      attachRadioListeners();
      setPolicyVisibility();
    }, 500);

    setTimeout(function () {
      attachRadioListeners();
      setPolicyVisibility();
    }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();